"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InstitutionsForm = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styled = _interopRequireDefault(require("../../theme/styled"));

var _theme = require("../../theme");

var _basis = require("basis");

var _env = _interopRequireDefault(require("../../env.config"));

var _ = require("./..");

var _hooks = require("../../hooks");

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var OptionLabel = _styled.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  & > img {\n    margin-left: 8px;\n    margin-right: 8px;\n    width: 82px;\n    height: 30px;\n    background-color: ", ";\n  }\n\n  & > span {\n    margin-left: 8px;\n  }\n"])), function (p) {
  return p.theme.basis.colors.grey.t10;
});

var s = {
  OptionLabel: OptionLabel
};

var institutionsToOptions = function institutionsToOptions(institutions, primary) {
  return institutions.map(function (item) {
    return {
      label: primary ? /*#__PURE__*/_react.default.createElement(s.OptionLabel, null, /*#__PURE__*/_react.default.createElement("img", {
        src: "".concat((0, _env.default)('PROVISO_IMAGES_BASE_URL'), "/").concat(item.slug, ".png"),
        alt: "",
        "aria-hidden": "true"
      }), /*#__PURE__*/_react.default.createElement("span", null, item.name)) : item.name,
      value: item.slug
    };
  });
};

var OTHER_VALUE = 'other';

var InstitutionsForm = function InstitutionsForm(props) {
  var data = props.data,
      onSelectInstitution = props.onSelectInstitution;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showSecondary = _useState2[0],
      setShowSecondary = _useState2[1];

  var radioGroupLabel = (0, _.useTextContent)('institutions.labelSelectInstitution');
  var selectLabel = (0, _.useTextContent)('institutions.labelSelectInstitutionSecondary');
  var selectPlaceholder = (0, _.useTextContent)('institutions.selectPlaceholder');
  var initialBackButton = (0, _hooks.useContextSelector)(function (ctx) {
    return ctx.config.initialBackButton;
  });
  var theme = (0, _theme.useTheme)();
  var primaryOptions = (0, _react.useMemo)(function () {
    if (data) {
      var otherOption = {
        label: /*#__PURE__*/_react.default.createElement(OptionLabel, {
          "data-testid": "OtherInstitutionsRadio"
        }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_.TextContent, {
          path: "institutions.labelOther"
        }))),
        value: OTHER_VALUE
      };
      return [].concat((0, _toConsumableArray2.default)(institutionsToOptions(data.primary, true)), [otherOption]);
    }
  }, [data]);
  var secondaryOptions = (0, _react.useMemo)(function () {
    if (data && showSecondary) {
      return institutionsToOptions(data.secondary);
    }
  }, [data, showSecondary]);

  var handleRadioOnChange = function handleRadioOnChange(_ref) {
    var selectedOption = _ref.selectedOption;

    if (selectedOption.value === OTHER_VALUE) {
      setShowSecondary(true);
    } else {
      setShowSecondary(false);
    }
  };

  var handleSubmit = function handleSubmit(state) {
    if (Object.keys(state.errors).length) {
      return;
    }

    if (state.values.institutionPrimary === OTHER_VALUE) {
      onSelectInstitution(state.values.institutionSecondary);
    } else {
      onSelectInstitution(state.values.institutionPrimary);
    }
  };

  if (!primaryOptions) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_.Form, {
    initialValues: {
      institutionPrimary: '',
      institutionSecondary: ''
    },
    onSubmit: handleSubmit
  }, function () {
    return /*#__PURE__*/_react.default.createElement(_.FormLayout, null, /*#__PURE__*/_react.default.createElement(_basis.RadioGroup, {
      name: "institutionPrimary",
      label: radioGroupLabel,
      columns: 1,
      options: primaryOptions,
      onChange: handleRadioOnChange,
      color: theme.inputColor
    }), showSecondary && secondaryOptions && /*#__PURE__*/_react.default.createElement(_basis.Container, {
      padding: "3 0"
    }, /*#__PURE__*/_react.default.createElement(_basis.Select, {
      testId: "OtherInstitutionsSelect",
      name: "institutionSecondary",
      label: selectLabel,
      options: secondaryOptions,
      placeholder: selectPlaceholder,
      color: theme.inputColor
    })), /*#__PURE__*/_react.default.createElement(_.FormButtonsLayout, null, /*#__PURE__*/_react.default.createElement(_.SubmitButton, null, /*#__PURE__*/_react.default.createElement(_.TextContent, {
      path: "institutions.buttonSubmit"
    })), initialBackButton));
  });
};

exports.InstitutionsForm = InstitutionsForm;